module.exports = __webpack_public_path__ + "static/img/pdf-icon.761ccfe8.svg";